const config = {
  apiEndpoint: process.env.API_ENDPOINT,
  clientId: process.env.USER_POOL_CLIENT_ID,
  poolId: process.env.USER_POOL_ID,
  MAX_CHUNK_SIZE_BYTES: Number(process.env.MAX_CHUNK_SIZE_BYTES),
  MIN_CHUNK_SIZE_BYTES: Number(process.env.MIN_CHUNK_SIZE_BYTES)
}

export default config